<template>
  <div class="toast">
    <div class="toast__body">
      <span class="d-block">
        {{ $t(`translation.toast.entity-type.${entityType.toLowerCase()}`) }}
        {{ ' ' }}
        {{
          $t('translation.toast.info', {
            language: $t(`knowledge.languages.${language}`),
          })
        }}
      </span>
      <el-button
        @click="$emit('open-set-language-modal')"
        class="mt-2"
        type="primary"
        size="mini"
      >
        {{ $t('translation.toast.set-language', { lang }) }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'set-language-toast',
  props: {
    language: {
      type: String,
    },
    entityType: {
      type: String,
      default: 'case',
    },
  },
  computed: {
    lang() {
      const lang = this.$t(`knowledge.languages.${this.language}`);
      return lang.charAt(0).toUpperCase() + lang.substring(1, 2);
    },
  },
};
</script>

<style lang="scss" scoped>
.toast {
  position: absolute;
  max-width: 250px;
  font-size: 14px;
  border-radius: 2px;
  border-left: 4px solid $red-mayday;
  background-color: white;
  overflow: hidden;
  z-index: 999;

  &__body {
    padding: 8px;
    background: $grey-1-mayday;
  }
}
</style>
